import React from 'react';

const PageName = ({ name }) => {
  return <h3 className="col-lg-6 overview-part">{name}</h3>;
};

export default PageName;
